
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trauma-and-critical-care",
      function () {
        return require("private-next-pages/trauma-and-critical-care.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trauma-and-critical-care"])
      });
    }
  